import { AbstractModel } from '@/models/base'
import type { IForm, IFormData, IFormRevision, IFormRevisionData } from './form.types'

/**
 * A class representing an Form.
 */
export class Form extends AbstractModel implements IForm {
  readonly id?: number
  readonly title: string
  readonly description: string

  constructor(data: IFormData) {
    super()

    // Validate data
    const requiredFields: (keyof IFormData)[] = ['title', 'description']
    this.validate(data, requiredFields)

    this.title = data.title!
    this.description = data.description!

    if (data.id) {
      this.id = data.id
    }
  }

  toString() {
    return this.title
  }
}

/**
 * A class representing an Form.
 */
export class FormRevision extends AbstractModel implements IFormRevision {
  readonly id?: number
  readonly owner?: string
  readonly form: IForm

  constructor(data: IFormRevisionData) {
    super()

    // Validate data
    this.validate(data, ['form'])

    if (data.id) {
      this.id = data.id
    }

    if (data.owner) {
      this.owner = data.owner
    }

    this.form = new Form(data.form!)
  }

  toString() {
    return this.form.toString()
  }
}
